import { Code, ConnectError } from '@bufbuild/connect';

import { createErrorReportingInterceptor } from './createErrorReportingInterceptor';

let unauthenticatedHandler: (() => void) | undefined;

// The app decides what an ended session means: shared/api cannot reach the
// store or the router.
export const setUnauthenticatedHandler = (handler: () => void) => {
  unauthenticatedHandler = handler;
};

export const unauthenticatedInterceptor = createErrorReportingInterceptor(
  (error) => {
    if (ConnectError.from(error).code === Code.Unauthenticated) {
      unauthenticatedHandler?.();
    }
  },
);
